<ng-container *transloco="let t;">
  <div class="table-responsive">
    <app-skeleton *ngIf="loading" [loop]="7" [section]="'templatesMainSection'"></app-skeleton>

    <div *ngIf="!loading">
      <ngx-datatable
        class="bootstrap core-bootstrap datatable-bordered virtualized material datatable-striped expandable"
        [headerHeight]="40" [rowHeight]="58" [rows]="displayTemplateListing" [columnMode]="ColumnMode.force"
        [selectAllRowsOnPage]="false" [scrollbarV]="true" [scrollbarH]="true" [enableClearingSortState]="true"
        [sorts]="[{ prop: 'template.updated_at', dir: 'desc' }]"
        [messages]="{ emptyMessage: t('Template listing - No template found (template listing table label) - No template found') }">
        <!-- Render columns from the columns config -->
        <ngx-datatable-column *ngFor="let col of columns" [name]="t(col.nameKey)" [prop]="col.prop"
          [sortable]="col.sortable" [draggable]="col.reorderable" [resizeable]="col.resizable" [maxWidth]="col.maxWidth"
          [width]="col.width">

          <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
            <ng-container [ngSwitch]="col.field">

              <!-- Template / Name -->
              <ng-container *ngSwitchCase="'name'">
                <div class="media align-items-center">
                  @if(row?.template_details?.type !== templateType.EFORM){
                  <app-template-icon [type]="row?.template_details?.type"
                    [cssVariant]="row.template?.status === 1 ? 'bg-light-primary' : 'bg-light-secondary'">
                  </app-template-icon>
                  }
                  <div class="media-body" [ngClass]="{'ms-1': row?.template_details?.type !== templateType.EFORM}">
                    <a href="javascript:void(0)" (click)="goToEditArea(row)"
                      class="fw-bold d-block text-nowrap text-primary mb-0">
                      {{ row.template?.name }}
                    </a>
                    <small placement="top" [autoClose]="true" triggers="hover" container="body"
                      [ngbTooltip]="t('Document type label (general) - Document type')">
                      {{ (row.template_details?.document_type_id | getDocumentType) | async }}
                    </small>
                  </div>
                </div>
              </ng-container>

              <!-- Language -->
              <ng-container *ngSwitchCase="'language'">
                <span>{{ t('language navbar list (navbar) - ' + (row.template_details?.language | titlecase)) }}</span>
              </ng-container>

              <!-- Owner -->
              <ng-container *ngSwitchCase="'owner'">
                <span class="text-nowrap" container="body" [class.deleted-user]="!!row?.template_owner?.deleted_at"
                  [ngbTooltip]="row?.template_owner?.deleted_at 
        ? t('Deleted user action label (general) - Deleted user')
        : (row?.template?.created_at | dateFormat | async)" placement="top">
                  {{ row?.template_owner?.name || 'Unknown User' }}
                </span>
              </ng-container>

              <!-- Last Edited -->
              <ng-container *ngSwitchCase="'updated_at'">
                <span>{{ row.template?.updated_at | dateFormat | async }}</span>
              </ng-container>

              <!-- Status + Actions -->
              <ng-container *ngSwitchCase="'status'">
                <div class="d-flex align-items-center">
                  <div class="custom-control custom-switch custom-control-inline" placement="top" [autoClose]="true"
                    triggers="hover" container="body"
                    [ngbTooltip]="t('Permission toaster text (General) - You dont have permission to edit this template')"
                    [disableTooltip]="((row?.template?.id | templatePermission: row?.template_details?.document_type_id: getTemplateCategoryIds(row) :  row?.template  : accessLeveLEnum.use_and_edit) | async) === true">
                    <input #status type="checkbox" class="custom-control-input template-status-switch"
                      [id]="'status' + row.template?.id"
                      [disabled]="((row?.template?.id | templatePermission: row?.template_details?.document_type_id: getTemplateCategoryIds(row) :  row?.template : accessLeveLEnum.use_and_edit) | async) === false"
                      [checked]="row.template?.status"
                      (change)="publishTemplate(status, getOriginalIndex(row), $event)" />
                    <label class="custom-control-label" [for]="'status' + row.template?.id"
                      *ngIf="row.template?.status || status.checked">
                      {{ t('Template listing - Template status column (published) - Published') }}
                    </label>
                    <label class="custom-control-label" [for]="'status' + row.template?.id"
                      *ngIf="!row.template?.status && !status.checked">
                      {{ t('Template listing - Template status column (draft) - Draft') }}
                    </label>
                  </div>

                  <div ngbDropdown container="body" class="actionTD template-listing-action-btn ms-2">
                    <button type="button" class="btn btn-sm hide-arrow" ngbDropdownToggle data-toggle="dropdown">
                      <i data-feather="more-vertical"></i>
                    </button>
                    <div ngbDropdownMenu class="dropdown-menu-right">
                      <a *ngIf="((row?.template?.id | templatePermission: row?.template_details?.document_type_id: getTemplateCategoryIds(row) :  row?.template  : accessLeveLEnum.use_only) | async) && (row?.template_details?.type !== templateType.EFORM)"
                        ngbDropdownItem href="javascript:void(0)"
                        [ngClass]="{'opacity-50 pointer-none': sendForSignatureLoader}"
                        (click)="sendForSignature(row, row.template.id)">
                        <i data-feather="send" [size]="16" class="me-50"></i>
                        <span>{{ t('Template listing - Table menu (Send for signature - label) - Send for signature')
                          }}</span>
                      </a>

                      <a *ngIf="(row?.template?.id | templatePermission: row?.template_details?.document_type_id: getTemplateCategoryIds(row) :  row?.template  : accessLeveLEnum.use_and_edit) | async"
                        ngbDropdownItem href="javascript:void(0);" (click)="goToEditArea(row)">
                        <i data-feather="edit-2" [size]="16" class="me-50"></i>
                        <span>{{ t('Edit label - Edit') }}</span>
                      </a>

                      <a *ngIf="(row?.template?.id | templatePermission: row?.template_details?.document_type_id: getTemplateCategoryIds(row) :  row?.template  : accessLeveLEnum.use_and_edit) | async"
                        ngbDropdownItem href="javascript:void(0);" (click)="duplicateTemplateModal(row, templateModal)">
                        <i data-feather="copy" [size]="16" class="me-50"></i>
                        <span>{{ t('Duplicate label - Duplicate') }}</span>
                      </a>

                      <a *ngIf="(row?.template?.id | templatePermission: row?.template_details?.document_type_id: getTemplateCategoryIds(row) :  row?.template  : accessLeveLEnum.full_access) | async"
                        ngbDropdownItem href="javascript:void(0);" (click)="deleteTemplate(row)">
                        <i data-feather="trash" [size]="16" class="me-50"></i>
                        <span>{{ t('Delete permanently - label (general) - Delete permanently') }}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </ng-container>

            </ng-container>
          </ng-template>

        </ngx-datatable-column>

      </ngx-datatable>

      <!-- pagination unchanged -->
      <div class="d-flex justify-content-between align-content-center mt-1 w-100">
        <div class="mt-2 ms-1">
          <p class="mb-0 font-small-3">{{ t('Total Templates - Total') }}: {{ pagination?.total }}</p>
        </div>
        <ngb-pagination *ngIf="pagination" class="d-flex justify-content-end mt-1 me-1"
          (pageChange)="onPageChange($event)" [collectionSize]="pagination.total" [(page)]="page" [maxSize]="3">
          <ng-template ngbPaginationPrevious>
            <span [data-feather]="'chevron-left'" [size]="18" class="fw-bolder"></span>
          </ng-template>
          <ng-template ngbPaginationNext>
            <span [data-feather]="'chevron-right'" [size]="18" class="fw-bolder"></span>
          </ng-template>
        </ngb-pagination>
      </div>

    </div>
  </div>
  <!-- Modal -->
  <ng-template #templateModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="myModalLabel1">{{ t('Template listing - Duplicate template modal (duplicate template
        modal - title) - Duplicate template') }}</h4>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <form [formGroup]="renameTemplateForm" (ngSubmit)="duplicateTemplate()">
      <div class="modal-body" tabindex="0" ngbAutofocus>
        <label>{{ t('Template name - field title (general) - Template name') }}</label>
        <div class="form-group">
          <input type="text" formControlName="name"
            placeholder="{{ t('Template name - field title (general) - Template name') }}" class="form-control"
            [ngClass]="{ 'is-invalid error': submitted && form.name.errors }" />
          <div *ngIf="submitted && form.name.errors" class="invalid-feedback"
            [ngClass]="{ 'd-block': submitted && form.name.errors }">
            <div *ngIf="form.name.errors.required">{{t('Field required (form validation) - Field name is required', {
              fieldName: t('Template name - field title (general) - Template name')
              })}}</div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="reset" class="btn btn-outline-secondary" (click)="modal.dismiss('Cross click')" rippleEffect>
          {{ t('Cancel button text (cancel button) - cancel') }}
        </button>
        <button type="submit" class="btn btn-primary" rippleEffect>
          <span *ngIf="formLoader" class="spinner-border spinner-border-sm me-1"></span> {{ t('Duplicate label -
          Duplicate') }}
        </button>
      </div>
    </form>
  </ng-template>
  <!-- / Modal -->
</ng-container>